module.exports = __webpack_public_path__ + "img/ill_spot_failed_scan_stt.964f8cee.svg";